import React, { useCallback, useRef, useState, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, AllCommunityModule } from 'ag-grid-community';
import { ModuleRegistry, themeBalham } from 'ag-grid-community';
import formatNumber from '../../../utils/formatters/formatNumber';
import { FDetailShift } from '../../../utils/types/FDetailShift';

ModuleRegistry.registerModules([AllCommunityModule]);

interface DetailShiftGridGridProps {
    items: FDetailShift[];
}

const DetailShiftGrid: React.FC<DetailShiftGridGridProps> = ({ items }) => {
    const gridRef = useRef<AgGridReact>(null);

    const [columnDefs] = useState<ColDef<FDetailShift>[]>([
        { field: 'agent', headerName: 'Pompiste', sortable: true, filter: true },
        { field: 'designationPistolet', headerName: 'Pistolet', sortable: true, filter: true },
        { field: 'designationPompe', headerName: 'Pompe', sortable: true, filter: true, sort: 'asc' },
        { field: 'designationArticle', headerName: 'Article', sortable: true, filter: true },
        {
            field: 'prixCashCDF',
            headerName: 'Prix Cash (CDF)',
            sortable: true,
            valueFormatter: (params) => (params.value ? formatNumber(params.value, { maximumFractionDigits: 2 }) : ''),
            filter: 'agNumberColumnFilter',
            cellStyle: { textAlign: 'right' },
        },
    ]);

    // ---

    const myTheme = themeBalham.withParams({
        columnBorder: { style: 'dashed', width: '1px' },
    });

    // ---

    const exportAsCsv = useCallback(() => {
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');

        gridRef.current!.api.exportDataAsCsv({
            fileName: `details_shift_${timestamp}.csv`,
            allColumns: true,
            suppressQuotes: false,
        });
    }, []);

    return (
        <>
            <div className="" style={{ height: 600, width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    theme={myTheme}
                    getRowId={(params) => params.data.id?.toString() ?? Math.random().toString()}
                    getRowStyle={(params) => {
                        if (params.node.rowPinned === 'bottom') {
                            return {
                                fontWeight: 'bold',
                                backgroundColor: '#f8f9fa',
                            };
                        }
                        return undefined;
                    }}
                    columnDefs={columnDefs}
                    overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>"
                    rowData={items}
                    domLayout="normal"
                    defaultColDef={{
                        resizable: true,
                        minWidth: 100,
                        flex: 1,
                    }}
                    suppressExcelExport={true}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                    animateRows={true}
                />
            </div>

            <div className="dropdown mt-1">
                <button className="btn dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown">
                    Export
                </button>

                <ul className="dropdown-menu" aria-labelledby="exportDropdown">
                    <li>
                        <button className="dropdown-item" onClick={exportAsCsv}>
                            Export as CSV
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default DetailShiftGrid;
